// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 현금성자산 잔액관리 화면 */

/* ═══════════════════════════════════════
   분할 레이아웃
═══════════════════════════════════════ */
.bhp-split-root {
  display: flex;
  height: 100%;
  background-color: #f5f6fa;
  overflow: hidden;
}

/* 각 패널 (좌·우 공통) */
.bhp-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  min-width: 0;
}

/* 드래그 가능한 구분선 */
.bhp-divider {
  flex-shrink: 0;
  width: 6px;
  background: #d0d5e8;
  cursor: col-resize;
  transition: background 0.15s;
  position: relative;
  z-index: 10;
}
.bhp-divider:hover,
.bhp-divider:active {
  background: #4a90e2;
}

/* 패널 제목 바 */
.bhp-panel-title-bar {
  flex-shrink: 0;
  padding: 8px 14px 6px;
  background-color: #fff;
  border-bottom: 2px solid #e0e4ef;
}
.bhp-panel-title-bar h2 {
  margin: 0;
  font-size: 1.0rem;
  font-weight: 700;
  color: #1a1a2e;
}

/* 패널 툴바 */
.bhp-panel-toolbar {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 14px;
  background-color: #f8f9fc;
  border-bottom: 1px solid #e0e4ef;
}

/* 패널 바디 (flex:1 – 나머지 공간) */
.bhp-panel-body {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 10px 14px;
  gap: 8px;
  overflow: hidden;
}

/* ═══════════════════════════════════════
   좌측 패널 – 상단 요약 그리드
═══════════════════════════════════════ */
.bhp-summary-section {
  flex-shrink: 0;
}
.bhp-summary-wrapper {
  max-height: 230px;
  overflow-y: auto;
}

/* 현금잔액 스타일 */
.bhp-cash-bal {
  font-weight: 700;
}
.bhp-pos { color: #c0392b; }
.bhp-neg { color: #2980b9; }

/* ═══════════════════════════════════════
   좌측 패널 – 하단 입출금 내역 그리드
═══════════════════════════════════════ */
.bhp-history-section {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.bhp-history-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 0 6px;
  flex-shrink: 0;
}
.bhp-history-label {
  font-size: 12px;
  font-weight: 600;
  color: #444;
}
.bhp-history-btns {
  display: flex;
  gap: 6px;
}

.bhp-history-wrapper {
  flex: 1 1;
  min-height: 0;
  overflow: auto;
}

/* 인라인 입력 셀 */
.bhp-cell-date {
  width: 100%;
  padding: 3px 5px;
  border: 1px solid #ddd;
  border-radius: 3px;
  font-size: 12px;
  font-family: inherit;
  background: white;
  box-sizing: border-box;
}
.bhp-cell-date:focus {
  outline: none;
  border-color: #4a90e2;
}

.bhp-cell-select {
  width: 100%;
  padding: 3px 4px;
  border: 1px solid #ddd;
  border-radius: 3px;
  font-size: 12px;
  font-family: inherit;
  background: white;
  box-sizing: border-box;
}
.bhp-cell-select:focus {
  outline: none;
  border-color: #4a90e2;
}

.bhp-cell-amt {
  width: 100%;
  padding: 3px 5px;
  border: 1px solid #ddd;
  border-radius: 3px;
  font-size: 12px;
  font-family: inherit;
  background: white;
  text-align: right;
  box-sizing: border-box;
}
.bhp-cell-amt:focus {
  outline: none;
  border-color: #4a90e2;
}

.bhp-cell-memo {
  width: 100%;
  padding: 3px 5px;
  border: 1px solid #ddd;
  border-radius: 3px;
  font-size: 12px;
  font-family: inherit;
  background: white;
  box-sizing: border-box;
}
.bhp-cell-memo:focus {
  outline: none;
  border-color: #4a90e2;
}

/* ═══════════════════════════════════════
   툴바 공통
═══════════════════════════════════════ */
.bh-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.bh-label {
  font-size: 12px;
  font-weight: 600;
  color: #444;
  flex-shrink: 0;
}

.bh-select {
  padding: 5px 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 12px;
  font-family: inherit;
  background: white;
  min-width: 110px;
}

/* ═══════════════════════════════════════
   우측 그리드 – 기존 스타일 유지
═══════════════════════════════════════ */
.bh-grid tbody tr.bh-row-latest {
  background-color: #fffde7;
}
.bh-grid tbody tr.bh-row-latest:hover td {
  background-color: #fff9c4;
}
.bh-amount { font-weight: 600; }
.bh-memo   { color: #555; font-size: 12px; }

.bh-sortable { cursor: pointer; -webkit-user-select: none; user-select: none; }
.bh-sortable:hover { background-color: #e8ebf8; }

.bh-resizable-th { position: relative; }
.bh-resize-handle {
  position: absolute;
  right: 0; top: 0; bottom: 0;
  width: 5px;
  cursor: col-resize;
  z-index: 2;
}
.bh-resize-handle:hover { background: rgba(74, 144, 226, 0.35); }

/* 텍스트 말줄임 */
.col-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ═══════════════════════════════════════
   아이콘 버튼
═══════════════════════════════════════ */
.btn-icon {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  padding: 2px 5px;
  border-radius: 3px;
  transition: background 0.15s;
}
.btn-icon:hover     { background-color: #e8eaf6; }
.btn-icon-del:hover { background-color: #ffeaea; }

/* ═══════════════════════════════════════
   오버레이 & 팝업 (우측 패널)
═══════════════════════════════════════ */
.bh-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.bh-popup {
  background: white;
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  min-width: 400px;
  max-width: 500px;
  width: 100%;
}
.bh-popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px 12px;
  border-bottom: 1px solid #eee;
  font-size: 15px;
  font-weight: 600;
  color: #1a1a2e;
}
.bh-popup-close {
  background: none; border: none;
  font-size: 16px; cursor: pointer; color: #888;
  padding: 2px 6px; border-radius: 3px;
}
.bh-popup-close:hover { background: #f0f0f0; color: #333; }

.bh-popup-body {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.bh-form-row {
  display: flex;
  align-items: center;
  gap: 10px;
}
.bh-form-label {
  font-size: 12px; font-weight: 600; color: #444;
  width: 80px; flex-shrink: 0; text-align: right;
}
.bh-form-input {
  flex: 1 1;
  padding: 6px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 13px;
  font-family: inherit;
}
.bh-form-input:focus {
  outline: none;
  border-color: #4a90e2;
  box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.15);
}
.bh-form-input[disabled] { background: #f5f5f5; color: #888; cursor: not-allowed; }
.bh-right { text-align: right; }

.bh-popup-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 20px 16px;
  border-top: 1px solid #eee;
}

/* ═══════════════════════════════════════
   삭제 확인 팝업
═══════════════════════════════════════ */
.bh-confirm {
  background: white;
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  padding: 28px 32px 24px;
  min-width: 340px;
  max-width: 440px;
  text-align: center;
}
.bh-confirm-msg    { font-size: 14px; font-weight: 600; color: #1a1a2e; margin: 0 0 8px; }
.bh-confirm-detail { font-size: 12px; color: #666; margin: 0 0 20px; }
.bh-confirm-btns   { display: flex; justify-content: center; gap: 10px; }

/* ═══════════════════════════════════════
   버튼 – 추가 색상 정의
═══════════════════════════════════════ */
.btn-success {
  background-color: #28a745; color: white;
  border: none; padding: 6px 14px;
  border-radius: 4px; font-size: 12px;
  cursor: pointer; font-family: inherit;
}
.btn-success:hover { background-color: #218838; }

.btn-danger {
  background-color: #dc3545; color: white;
  border: none; padding: 6px 14px;
  border-radius: 4px; font-size: 12px;
  cursor: pointer; font-family: inherit;
}
.btn-danger:hover { background-color: #c82333; }
`, "",{"version":3,"sources":["webpack://./src/pages/trade/BalanceHistoryPage.css"],"names":[],"mappings":"AAAA,kBAAkB;;AAElB;;yCAEyC;AACzC;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,cAAc;EACd,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;EAClB,WAAW;AACb;AACA;;EAEE,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,cAAc;EACd,qBAAqB;EACrB,sBAAsB;EACtB,gCAAgC;AAClC;AACA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA,4BAA4B;AAC5B;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;;yCAEyC;AACzC;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,gBAAgB;AAClB;AACA,WAAW,cAAc,EAAE;AAC3B,WAAW,cAAc,EAAE;;AAE3B;;yCAEyC;AACzC;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,aAAa;EACb,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;;yCAEyC;AACzC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;yCAEyC;AACzC;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA,aAAa,gBAAgB,EAAE;AAC/B,aAAa,WAAW,EAAE,eAAe,EAAE;;AAE3C,eAAe,eAAe,EAAE,yBAAiB,EAAjB,iBAAiB,EAAE;AACnD,qBAAqB,yBAAyB,EAAE;;AAEhD,mBAAmB,kBAAkB,EAAE;AACvC;EACE,kBAAkB;EAClB,QAAQ,EAAE,MAAM,EAAE,SAAS;EAC3B,UAAU;EACV,kBAAkB;EAClB,UAAU;AACZ;AACA,0BAA0B,oCAAoC,EAAE;;AAEhE,YAAY;AACZ;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;yCAEyC;AACzC;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;AAC9B;AACA,sBAAsB,yBAAyB,EAAE;AACjD,sBAAsB,yBAAyB,EAAE;;AAEjD;;yCAEyC;AACzC;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB,EAAE,YAAY;EAC9B,eAAe,EAAE,eAAe,EAAE,WAAW;EAC7C,gBAAgB,EAAE,kBAAkB;AACtC;AACA,wBAAwB,mBAAmB,EAAE,WAAW,EAAE;;AAE1D;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,eAAe,EAAE,gBAAgB,EAAE,WAAW;EAC9C,WAAW,EAAE,cAAc,EAAE,iBAAiB;AAChD;AACA;EACE,SAAO;EACP,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;AACA,2BAA2B,mBAAmB,EAAE,WAAW,EAAE,mBAAmB,EAAE;AAClF,YAAY,iBAAiB,EAAE;;AAE/B;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;;yCAEyC;AACzC;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA,qBAAqB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,eAAe,EAAE;AACzF,qBAAqB,eAAe,EAAE,WAAW,EAAE,gBAAgB,EAAE;AACrE,qBAAqB,aAAa,EAAE,uBAAuB,EAAE,SAAS,EAAE;;AAExE;;yCAEyC;AACzC;EACE,yBAAyB,EAAE,YAAY;EACvC,YAAY,EAAE,iBAAiB;EAC/B,kBAAkB,EAAE,eAAe;EACnC,eAAe,EAAE,oBAAoB;AACvC;AACA,qBAAqB,yBAAyB,EAAE;;AAEhD;EACE,yBAAyB,EAAE,YAAY;EACvC,YAAY,EAAE,iBAAiB;EAC/B,kBAAkB,EAAE,eAAe;EACnC,eAAe,EAAE,oBAAoB;AACvC;AACA,oBAAoB,yBAAyB,EAAE","sourcesContent":["/* 현금성자산 잔액관리 화면 */\n\n/* ═══════════════════════════════════════\n   분할 레이아웃\n═══════════════════════════════════════ */\n.bhp-split-root {\n  display: flex;\n  height: 100%;\n  background-color: #f5f6fa;\n  overflow: hidden;\n}\n\n/* 각 패널 (좌·우 공통) */\n.bhp-panel {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: hidden;\n  min-width: 0;\n}\n\n/* 드래그 가능한 구분선 */\n.bhp-divider {\n  flex-shrink: 0;\n  width: 6px;\n  background: #d0d5e8;\n  cursor: col-resize;\n  transition: background 0.15s;\n  position: relative;\n  z-index: 10;\n}\n.bhp-divider:hover,\n.bhp-divider:active {\n  background: #4a90e2;\n}\n\n/* 패널 제목 바 */\n.bhp-panel-title-bar {\n  flex-shrink: 0;\n  padding: 8px 14px 6px;\n  background-color: #fff;\n  border-bottom: 2px solid #e0e4ef;\n}\n.bhp-panel-title-bar h2 {\n  margin: 0;\n  font-size: 1.0rem;\n  font-weight: 700;\n  color: #1a1a2e;\n}\n\n/* 패널 툴바 */\n.bhp-panel-toolbar {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 14px;\n  background-color: #f8f9fc;\n  border-bottom: 1px solid #e0e4ef;\n}\n\n/* 패널 바디 (flex:1 – 나머지 공간) */\n.bhp-panel-body {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  padding: 10px 14px;\n  gap: 8px;\n  overflow: hidden;\n}\n\n/* ═══════════════════════════════════════\n   좌측 패널 – 상단 요약 그리드\n═══════════════════════════════════════ */\n.bhp-summary-section {\n  flex-shrink: 0;\n}\n.bhp-summary-wrapper {\n  max-height: 230px;\n  overflow-y: auto;\n}\n\n/* 현금잔액 스타일 */\n.bhp-cash-bal {\n  font-weight: 700;\n}\n.bhp-pos { color: #c0392b; }\n.bhp-neg { color: #2980b9; }\n\n/* ═══════════════════════════════════════\n   좌측 패널 – 하단 입출금 내역 그리드\n═══════════════════════════════════════ */\n.bhp-history-section {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.bhp-history-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 4px 0 6px;\n  flex-shrink: 0;\n}\n.bhp-history-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #444;\n}\n.bhp-history-btns {\n  display: flex;\n  gap: 6px;\n}\n\n.bhp-history-wrapper {\n  flex: 1;\n  min-height: 0;\n  overflow: auto;\n}\n\n/* 인라인 입력 셀 */\n.bhp-cell-date {\n  width: 100%;\n  padding: 3px 5px;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  font-size: 12px;\n  font-family: inherit;\n  background: white;\n  box-sizing: border-box;\n}\n.bhp-cell-date:focus {\n  outline: none;\n  border-color: #4a90e2;\n}\n\n.bhp-cell-select {\n  width: 100%;\n  padding: 3px 4px;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  font-size: 12px;\n  font-family: inherit;\n  background: white;\n  box-sizing: border-box;\n}\n.bhp-cell-select:focus {\n  outline: none;\n  border-color: #4a90e2;\n}\n\n.bhp-cell-amt {\n  width: 100%;\n  padding: 3px 5px;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  font-size: 12px;\n  font-family: inherit;\n  background: white;\n  text-align: right;\n  box-sizing: border-box;\n}\n.bhp-cell-amt:focus {\n  outline: none;\n  border-color: #4a90e2;\n}\n\n.bhp-cell-memo {\n  width: 100%;\n  padding: 3px 5px;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  font-size: 12px;\n  font-family: inherit;\n  background: white;\n  box-sizing: border-box;\n}\n.bhp-cell-memo:focus {\n  outline: none;\n  border-color: #4a90e2;\n}\n\n/* ═══════════════════════════════════════\n   툴바 공통\n═══════════════════════════════════════ */\n.bh-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.bh-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #444;\n  flex-shrink: 0;\n}\n\n.bh-select {\n  padding: 5px 8px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 12px;\n  font-family: inherit;\n  background: white;\n  min-width: 110px;\n}\n\n/* ═══════════════════════════════════════\n   우측 그리드 – 기존 스타일 유지\n═══════════════════════════════════════ */\n.bh-grid tbody tr.bh-row-latest {\n  background-color: #fffde7;\n}\n.bh-grid tbody tr.bh-row-latest:hover td {\n  background-color: #fff9c4;\n}\n.bh-amount { font-weight: 600; }\n.bh-memo   { color: #555; font-size: 12px; }\n\n.bh-sortable { cursor: pointer; user-select: none; }\n.bh-sortable:hover { background-color: #e8ebf8; }\n\n.bh-resizable-th { position: relative; }\n.bh-resize-handle {\n  position: absolute;\n  right: 0; top: 0; bottom: 0;\n  width: 5px;\n  cursor: col-resize;\n  z-index: 2;\n}\n.bh-resize-handle:hover { background: rgba(74, 144, 226, 0.35); }\n\n/* 텍스트 말줄임 */\n.col-ellipsis {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* ═══════════════════════════════════════\n   아이콘 버튼\n═══════════════════════════════════════ */\n.btn-icon {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 14px;\n  padding: 2px 5px;\n  border-radius: 3px;\n  transition: background 0.15s;\n}\n.btn-icon:hover     { background-color: #e8eaf6; }\n.btn-icon-del:hover { background-color: #ffeaea; }\n\n/* ═══════════════════════════════════════\n   오버레이 & 팝업 (우측 패널)\n═══════════════════════════════════════ */\n.bh-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.35);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.bh-popup {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\n  min-width: 400px;\n  max-width: 500px;\n  width: 100%;\n}\n.bh-popup-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px 12px;\n  border-bottom: 1px solid #eee;\n  font-size: 15px;\n  font-weight: 600;\n  color: #1a1a2e;\n}\n.bh-popup-close {\n  background: none; border: none;\n  font-size: 16px; cursor: pointer; color: #888;\n  padding: 2px 6px; border-radius: 3px;\n}\n.bh-popup-close:hover { background: #f0f0f0; color: #333; }\n\n.bh-popup-body {\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n.bh-form-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.bh-form-label {\n  font-size: 12px; font-weight: 600; color: #444;\n  width: 80px; flex-shrink: 0; text-align: right;\n}\n.bh-form-input {\n  flex: 1;\n  padding: 6px 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 13px;\n  font-family: inherit;\n}\n.bh-form-input:focus {\n  outline: none;\n  border-color: #4a90e2;\n  box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.15);\n}\n.bh-form-input[disabled] { background: #f5f5f5; color: #888; cursor: not-allowed; }\n.bh-right { text-align: right; }\n\n.bh-popup-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 12px 20px 16px;\n  border-top: 1px solid #eee;\n}\n\n/* ═══════════════════════════════════════\n   삭제 확인 팝업\n═══════════════════════════════════════ */\n.bh-confirm {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\n  padding: 28px 32px 24px;\n  min-width: 340px;\n  max-width: 440px;\n  text-align: center;\n}\n.bh-confirm-msg    { font-size: 14px; font-weight: 600; color: #1a1a2e; margin: 0 0 8px; }\n.bh-confirm-detail { font-size: 12px; color: #666; margin: 0 0 20px; }\n.bh-confirm-btns   { display: flex; justify-content: center; gap: 10px; }\n\n/* ═══════════════════════════════════════\n   버튼 – 추가 색상 정의\n═══════════════════════════════════════ */\n.btn-success {\n  background-color: #28a745; color: white;\n  border: none; padding: 6px 14px;\n  border-radius: 4px; font-size: 12px;\n  cursor: pointer; font-family: inherit;\n}\n.btn-success:hover { background-color: #218838; }\n\n.btn-danger {\n  background-color: #dc3545; color: white;\n  border: none; padding: 6px 14px;\n  border-radius: 4px; font-size: 12px;\n  cursor: pointer; font-family: inherit;\n}\n.btn-danger:hover { background-color: #c82333; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
